import {
  collection,
  getDocs,
  addDoc,
  query,
  where,
  orderBy,
  or,
  and,
  doc,
  updateDoc,
  deleteDoc,
  getDoc,
  setDoc,
  Timestamp,
  writeBatch,
  limit
} from "firebase/firestore";
import { firestore } from "_utils/firebase-app";
import fire from "_utils/firebase-app";
import { getToken } from "./user-service";
import axios from "axios";
import { add } from "date-fns";
import moment from 'moment';

export const checkUser = async (params) => {

  let url = "/api/v1/mobileusers/user/checkUser/" + params.email;
  console.log("[CreateEmployee] service checkUser start", { email: params.email, authority: params.authority, url });

  return new Promise(async (resolve, reject) => {
    try {
      // check that an employee does not already exist with the same email and employee id in the same airport
      // Check if any document has the same email

      // Create a reference to the 'employees' collection
      const employeesCollection = collection(firestore, "employee");

      // Create a query to check if the employee document with the given email,  and airport exists
      const emailQuery = query(
        employeesCollection,
        where("email", "==", params.email),
        where("airport", "==", params.authority)
      );

      console.log("[CreateEmployee] service checkUser — querying Firestore employee collection by email");
      const hasSameEmail = !(await getDocs(emailQuery)).empty;

      if (hasSameEmail) {
        console.warn("[CreateEmployee] service checkUser — email already exists in Firestore", params.email);
        throw new Error(
          "Email already exists with anothere employee in the airport"
        );
      }

      // get access token
      console.log("[CreateEmployee] service checkUser — fetching auth token");
      const token = await getToken();

      // make request
      console.log("[CreateEmployee] service checkUser — GET", url);
      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "firebase-uid": token,
        },
      });

      // handle response
      let json = await response.json();
      console.log("[CreateEmployee] service checkUser — response", { status: response.status, body: json });

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Issue trying to check user");
      } else {
        resolve(json);
      }
    } catch (error) {
      console.error("[CreateEmployee] service checkUser failed:", error?.message || error);
      reject(error);
    }
  });
};

export const acceptUnplannedTask = async (task) => {
  return new Promise(async (resolve, reject) => {
    try {
      const documentRef = doc(firestore, `tasks/${task["_id"]}`);

      // Update the document with the new data
      await updateDoc(documentRef, task);
      resolve(task);
    } catch (error) {
      console.error("Error in accept Unplanned Task:", error);
      reject(error);
    }
  });
};

export const unplanTask = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      // get access token
      const token = await getToken();

      const url = `/api/v1/timeline/timeline/unplanTask/${params.iata}/${params.taskId}`;
      const body = {
        bookingIds: params.bookingIds,

      }
      // if (params.taskId.includes("breakTask")) {
      //   const result = await unplanPendingTask(params.taskId)
      //   resolve(result)
      // } else {
      // make request
      const response = await fetch(url, {
        method: "DELETE",
        // body: JSON.stringify(body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "firebase-uid": token,
        },
      });
      const json = await response.json()

      if (response.status >= 400 && response.status < 600) {
        throw new Error(json);
      } else {
        resolve(json);
      }

      // }

    } catch (error) {
      console.error("Error unplanning task", error);
      reject(error);
    }
  });
};

export const unplanPendingTask = async (taskId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const documentRef = doc(firestore, `tasks/${taskId}`);

      // set data
      await deleteDoc(documentRef);
      resolve({ _id: taskId });
    } catch (error) {
      console.error("Error deleting task:", error);
      reject(error);
    }
  });
};

export const updateEmployee = async (employee) => {
  return new Promise(async (resolve, reject) => {
    try {
      const url = "/api/v1/mobileusers/user/patchEmployee/" + employee.userId;
      const token = await getToken();
      // make request
      const response = await fetch(url, {
        method: "PATCH",
        body: JSON.stringify(employee.body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "firebase-uid": token,
        },
      });
      const json = await response.json()
      if (response.status >= 400 && response.status < 600) {
        throw new Error(json);
      } else {
        resolve(json);
      }

    } catch (error) {
      console.error("Error updating employee:", error);
      reject(error);
    }
  });
};

export const deleteEmployee = async (employee) => {

  return new Promise(async (resolve, reject) => {
    try {
      // get access token
      const token = await getToken();

      const url = `/api/v1/timeline/timeline/${employee?.airport}/deleteEmployee`;
      const body = {
        id: employee?.employeeId,
        email: employee?.email,
      }
      // make request
      const response = await fetch(url, {
        method: "DELETE",
        body: JSON.stringify(body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "firebase-uid": token,
        },
      });

      // handle response
      if (response.status == 201) {
        // const documentRef = doc(firestore, `employee/${employee?.employeeId}`);
        // console.log(documentRef, "response.statusresponse.status111111");


        // // set data
        // const res = await deleteDoc(documentRef);
        // console.log(res, "response.statusresponse.status2222222");

        resolve();
      } else {
        throw new Error("Error deleting employee")
      }
    } catch (error) {
      console.error("Error deleting employee:", error);
      reject(error);
    }
  });
};

export const sendEmployeeNotification = async (notification) => {

  let url = "/api/v1/mobileusers/notification/employee-notification";

  return new Promise(async (resolve, reject) => {
    try {
      // get access token
      const token = await getToken();

      // make request
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(notification),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "firebase-uid": token,
        },
      });

      // handle response
      let json = await response.json();

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Issue trying to send notification");
      } else {
        resolve(json);
      }
    } catch (error) {
      console.error("Error sending notification:", error);
      reject(error);
    }
  });
};

export const addEmployee = async (form) => {

  const url = "/api/v1/mobileusers/user/employee";
  console.log("[CreateEmployee] service addEmployee start", {
    title: form?.title,
    email: form?.email,
    role: form?.role,
    airport: form?.airport,
    status: form?.status,
    approved: form?.approved,
    url,
  });

  return new Promise(async (resolve, reject) => {
    try {
      console.log("[CreateEmployee] service addEmployee — fetching auth token");
      const token = await getToken();

      console.log("[CreateEmployee] service addEmployee — POST", url);
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(form),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      console.log("[CreateEmployee] service addEmployee — response", {
        status: response.status,
        body: json,
      });
      if (response.status >= 400 && response.status < 600) {
        const apiError = json?.error || json?.errors?.[0]?.msg || "Bad new employee details";
        console.error("[CreateEmployee] service addEmployee — API error", { status: response.status, apiError, body: json });
        throw new Error(apiError);
      }
      console.log("[CreateEmployee] service addEmployee success", {
        userId: json?.userId || json?.employeeId,
        email: json?.email,
      });
      resolve(json);
    } catch (e) {
      console.error("[CreateEmployee] service addEmployee failed:", e?.message || e);
      reject(new Error(e?.message || "Error adding new emplopyee"));
    }
  });
};

export const getEmployeeTasks = async (employeeId) => {
  const collectionRef = collection(firestore, "tasks");

  const q = query(collectionRef, where("employeeId", "==", employeeId));

  const querySnapshot = await getDocs(q);

  const data = querySnapshot.docs.map((doc) => {
    return doc.data(); // Get the document data and add it to the array
  });

  return data; // Return an array of document data for the specified airport
};

export const getEmployeeList = async (iata) => {
  const collectionRef = collection(firestore, "employee");

  const q = query(collectionRef, where("airport", "==", iata));

  const querySnapshot = await getDocs(q);

  const data = querySnapshot.docs.map((doc) => {
    return doc.data(); // Get the document data and add it to the array
  });

  return data; // Return an array of document data for the specified airport
};

export const createTask = async (task) => {
  const docRef = doc(collection(firestore, "tasks"), task["_id"]);
  await setDoc(docRef, task);
  return task;
};

export const updateTask = async (task, anynmous) => {
  const url = "/api/v1/timeline/tasks/updateTask/" + task.id;

  return new Promise(async (resolve, reject) => {
    try {
      const token = anynmous ? "123456789" : await getToken();

      const response = await fetch(url, {
        method: "PATCH",
        body: JSON.stringify(task),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad Task details");
      }
      resolve(json.task);
    } catch (e) {
      reject(new Error("Error updating task"));
    }
  });
};

export const updateTask_v1 = async (task) => {
  return new Promise(async (resolve, reject) => {
    try {
      const documentRef = doc(firestore, `tasks/${task["_id"]}`);

      // Update the document with the new data
      await updateDoc(documentRef, task);
      resolve(task);
    } catch (error) {
      console.error("Error in update Task:", error);
      reject(error);
    }
  });
};

export const updateAdhocTaskNotes = async (taskId, notes) => {
  return new Promise(async (resolve, reject) => {
    try {
      const documentRef = doc(firestore, `tasks/${taskId}`);
      await updateDoc(documentRef, { notes });
      resolve(notes);
    } catch (error) {
      console.error("Error updating adhoc task notes:", error);
      reject(error);
    }
  });
};

/**
 * Fetch tasks for a flight (with employee info). Used for flight audit report employee dropdown.
 *
 * @param {Object} params
 * @param {string} params.iata - Airport IATA code
 * @param {string} params.flightNumber - Flight number
 * @param {string} params.date - Flight date (YYYY-MM-DD)
 * @param {string} [params.type] - 'departures' | 'boarding' | 'ramp' | 'arrival' | 'ALTPICKUP'
 * @returns {Promise<Array>} Array of tasks with employeeName
 */
export const getFlightTasks = async (params) => {
  const token = await getToken();
  const { iata, flightNumber, date, type } = params;
  const queryParams = new URLSearchParams({
    flightNumber,
    date,
  });
  if (type) queryParams.append('type', type);
  const url = `/api/v1/timeline/tasks/getFlightTasks/${iata}?${queryParams.toString()}`;
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      'Firebase-UID': token,
    },
  });
  if (response.status >= 400 && response.status < 600) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.errors?.[0]?.msg || `Failed to get flight tasks: ${response.status}`);
  }
  return response.json();
};

export const getTaskList = async (iata) => {
  return new Promise(async (resolve, reject) => {
    try {
      const collectionRef = collection(firestore, "tasks");

      // Get the current date in the format "YYYY-MM-DD"
      const currentDate = new Date().toISOString().split("T")[0];
      // Create the first query for arrivals tasks
      const arrivalQuery = query(
        collectionRef,
        where("flightInformation.arrivalAirport", "==", iata),
        where("flightInformation.flightDate", "==", currentDate)
      );
      // Create the second query for departure tasks
      const departureQuery = query(
        collectionRef,
        where("flightInformation.departureAirport", "==", iata),
        where("flightInformation.flightDate", "==", currentDate)
      );

      // Execute both queries
      const [arrivalSnapshot, departureSnapshot] = await Promise.all([
        getDocs(arrivalQuery),
        getDocs(departureQuery),
      ]);
      // Combine results from both queries
      let tempArrivals = arrivalSnapshot.docs.map((doc) => doc.data());
      let tempDepartures = departureSnapshot.docs.map((doc) => doc.data());

      const data = [...tempArrivals, ...tempDepartures];
      resolve(data); // Return an array of documents matching the conditions
    } catch (error) {
      console.error("Error getting task list:", error);
      reject(error);
    }
  });
};

export const getAllTaskListWithFilter = async (props) => {
  return new Promise(async (resolve, reject) => {
    try {
      const collectionRef = collection(firestore, "tasks");
      const startDate = moment(new Date(props?.startDate)).format().split("T")[0];
      const endDate = moment(new Date(props?.endDate)).format().split("T")[0];
      const arrivalQuery = query(
        collectionRef,
        where("flightInformation.arrivalAirport", "==", props?.iata),
        where("flightInformation.flightTime", ">=", `${startDate}T00:00:00`),
        where("flightInformation.flightTime", "<", `${endDate}T23:59:59`)
      );

      // Create the second query for departure tasks
      const departureQuery = query(
        collectionRef,
        where("flightInformation.departureAirport", "==", props?.iata),
        where("flightInformation.flightTime", ">=", `${startDate}T00:00:00`),
        where("flightInformation.flightTime", "<", `${endDate}T23:59:59`)
      );

      // Execute both queries
      const [arrivalSnapshot, departureSnapshot] = await Promise.all([
        getDocs(arrivalQuery),
        getDocs(departureQuery),
      ]);

      // Combine results from both queries
      let tempArrivals = arrivalSnapshot.docs.map((doc) => doc.data());
      let tempDepartures = departureSnapshot.docs.map((doc) => doc.data());
      tempDepartures = Array.isFullArray(tempDepartures) ? tempDepartures?.filter((taskItem) => taskItem?.employeeId !== null) : [];


      if (props?.allTasks == false) {

        let isTransitBookingCondition = props?.isTransit; // filter if transitBooking or not
        let notPlannedCondition = props?.isPlanned == "bySystem" ? false : true; // filter if planned(the booking created from employee app or not) booking or not

        tempArrivals = Array.isFullArray(tempArrivals)
          ? tempArrivals?.filter(
            (row) =>
              row?.isTransitBooking === isTransitBookingCondition &&
              row?.notPlanned == notPlannedCondition
          )
          : [];
        tempDepartures = Array.isFullArray(tempDepartures)
          ? tempDepartures?.filter(
            (row) =>
              row?.isTransitBooking === isTransitBookingCondition &&
              row?.notPlanned == notPlannedCondition
          )
          : [];
      }
      const data = [...tempArrivals, ...tempDepartures];
      resolve(data); // Return the combined array of documents
    } catch (error) {
      console.error("Error getting task list:", error);

      if (error.code === "failed-precondition") {
        console.error(
          "Index creation required. Please create the necessary Firestore index."
        );
      }

      reject(error);
    }
  });
};

export const getBookings = async (params) => {
  const token = await getToken();
  const url =
    "/api/v1/bookings/bookings/" +
    params.iata +
    "?start=" +
    params.start +
    "&end=" +
    params.end +
    "&limit=" +
    params.limit +
    "&skip=0" +
    `&type=${params.type}` +
    `&source=${params.source || "none"}`;


  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json.data);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

export const getEmployeeProductivity = async (props) => {


  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      let allDocs = false;
      if (!props.date) {
        allDocs = true
      }
      const start = props.date ? moment(new Date(props?.date[0])).format().split("T")[0] : "";
      const end = props.date ? moment(add(new Date(props?.date[1]), { days: 1 })).format().split("T")[0] : ""

      const url = `/api/v1/timeline/timeline/employeeProductivity/${props.employeeId}?start=${start}&end=${end}&allDocs=${allDocs}&limit=${props.limit}&skip=${props.skip}`
      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad timeline area details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error adding timeline area"));
    }
  });

};

export const getTimelineAreas = async (iata) => {

  const token = await getToken();

  const url = "/api/v1/timeline/timeline/" + iata;


  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      resolve(response.data);
    } catch (e) {
      reject(new Error("error getting timeline areas"));
    }
  });
};

export const addTimelineArea = async (params) => {
  const url = "/api/v1/timeline/timeline/" + params?.iata;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params.body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad timeline area details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error adding timeline area"));
    }
  });
};

export const editTimelineArea = async (data) => {
  const url = "/api/v1/timeline/timeline/" + data?.id;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data.body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad timeline area details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error editing timeline area"));
    }
  });
};

export const deleteTimelineArea = async (params) => {
  const url = "/api/v1/timeline/timeline/" + params?.id;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "DELETE",
        body: JSON.stringify(params.body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad timeline area ID ");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error deleting timeline area"));
    }
  });
};

export const assignEmployeesWorkZone = async (props) => {
  try {
    const db = firestore; // Initialize your Firestore database
    const batch = writeBatch(db); // Create a batch write instance

    // Loop through each employee ID and prepare the batch update
    for (const employee of props) {
      if (employee?.employeeId) {
        const employeeQuery = query(
          collection(db, "employee"),
          where("employeeId", "==", employee.employeeId)
        );

        // execute the query
        const employeeSnapshot = await getDocs(employeeQuery);

        // check if the employee exists
        if (!employeeSnapshot.empty) {

          const docRef = employeeSnapshot.docs[0].ref; // get the document reference
          batch.update(docRef, {
            workZone: employee?.workZone ?? null,
          });
        } else {
          console.error(`Document does not exist for employeeId: ${employee?.employeeId}`);
        }
      }
    }

    // Commit the batch update
    await batch.commit();
    return props?.filter((row) => row?.workZone !== null); // Resolve with the selected workZone
  } catch (error) {
    console.error("Error in assign workZone and updating employee documents:", error);
    throw error; // Rethrow error to be handled by caller
  }
};

export const postBooking = async (booking) => {

  const bookingUrl = "/api/v1/bookings/bookings";

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(bookingUrl, {
        method: "POST",
        body: JSON.stringify(booking),
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let json = await response.json();

      if (response.status >= 400 && response.status < 600) {
        if (response.status == 400) {
          throw new Error(
            "There was an issue with the flight details submitted as we cannot find a relevant flight with the given information."
          );
        } else if (response.status == 500) {
          throw new Error(
            "There was an issue with the network resulting in an error"
          );
        } else if (response.status == 409) {
          throw new Error(
            "A booking  for this name and flight already exists."
          );
        } else {
          throw new Error("Unkown Error");
        }
      }
      resolve(json);
    } catch (error) {
      reject(new Error("Error creating your booking"));
    }
  });
};

export const patchBooking = async (booking) => {

  let local_url = "/api/v1/bookings/bookings";
  let token = null

  if (booking.token && booking.token == "confirming-booking") {
    local_url = local_url + `?firebase_uid=${booking.token}`;
  }

  token = await getToken();

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(local_url, {
        method: "PATCH",
        body: JSON.stringify(booking.newBooking || booking),
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error confirming your booking"));
    }
  });
};

export const deleteBooking = async (bookingId) => {


  let local_url = "/api/v1/bookings/bookings";

  const token = await getToken();

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${local_url}/${bookingId}`, {
        method: "DELETE",
        headers: { "Firebase-UID": token },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error deleting your booking"));
    }
  });
};

export const getAndroidAppVersion = async (iata) => {
  return new Promise(async (resolve, reject) => {
    try {

      // get access token
      const token = await getToken();

      const url = "/api/v1/timeline/" + "timeline/" + iata + '/version';

      const response = await fetch(url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });

      let json = await response.json();


      if (response.status >= 400 && response.status < 600) {
        throw ('Issue getting latest version of app...')
      }

      resolve(json);

    } catch (error) {
      console.error("Error getting latest version of app:", error);
      reject(error);
    }
  });
};

export const getAirportLocation = async (iata) => {

  const token = await getToken();

  const url = "/api/v1/timeline/airportLocations/" + iata;


  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      resolve(response.data);
    } catch (e) {
      reject(new Error("error getting airport Locations"));
    }
  });
};

export const addAirportLocation = async (params) => {
  const url = "/api/v1/timeline/airportLocations/" + params?.iata;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params.body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad airport Location details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error adding airport Location"));
    }
  });
};

export const editAirportLocation = async (data) => {
  const url = "/api/v1/timeline/airportLocations/" + data?.id;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data.body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad Airport Location details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error editing Airport Location"));
    }
  });
};

export const deleteAirportLocation = async (params) => {
  const url = "/api/v1/timeline/airportLocations/" + params?.id;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "DELETE",
        body: JSON.stringify(params.body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad airport Location ID ");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error deleting airport Location"));
    }
  });
};

export const paxCheckIn = async (data) => {
  const url = "/api/v1/bookings/bookings/paxCheckIn/" + data?.bookingId;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data.body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad paxCheckIn details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error paxCheckIn"));
    }
  });
};

export const paxCheckOut = async (bookingId) => {
  const url = "/api/v1/bookings/bookings/paxCheckOut/" + bookingId;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad paxCheckOut details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error paxCheckOut"));
    }
  });
};

export const arrivalPaxCheckIn = async (bookingId, body) => {
  const url = "/api/v1/bookings/bookings/arrivalPaxCheckIn/" + bookingId;
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("error in arrivalPaxCheckIn");
      }
      resolve(json);
    } catch (error) {
      reject(new Error("Error in arrivalPaxCheckIn"));
    }
  });
};

export const postBookings = async (params) => {
  try {
    const url = "/api/v1/bookings/bookings";

    const token = await getToken();

    const promises = params.bookings.map(async (booking, index) => {


      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(booking),
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();

      if (response.status >= 400 && response.status < 600) {
        if (response.status === 400) {
          throw new Error(
            "There was an issue with the flight details submitted as we cannot find a relevant flight with the given information."
          );
        } else if (response.status === 500) {
          throw new Error(
            "There was an issue connecting with the network resulting in an error. Check your connection or the PRM Server Status."
          );
        } else if (response.status === 409) {
          throw new Error(
            `A booking for this passenger ${booking.name} and flight ${booking.flightDetails.carrierCode}${booking.flightDetails.flightNumber} already exists.`,
          );
        } else if (response.status === 403) {
          throw new Error(
            `You are not authorized to add this booking. Please contact your administrator.`,
          );
        } else {
          throw new Error("Unknown Error");
        }
      }
      return json


    });

    const responses = await Promise.all(promises);

    let type = '';

    // need to use iata to find where bookings will be stored
    if (responses[0] && responses[0].flightConfirmationDetails && responses[0].flightConfirmationDetails) {
      if (responses[0].flightConfirmationDetails.origin && responses[0].flightConfirmationDetails.destination) {
        // check if arrival or destination
        if (responses[0].flightConfirmationDetails.origin === params.iata) {
          type = 'departure';
        }
        else if (responses[0].flightConfirmationDetails.destination === params.iata) {
          type = 'arrival'
        }
      }
    }
    return {
      response: responses,
      type: type
    };

  } catch (error) {
    console.error('Error during booking submission:', error);
    throw error
  }
};

// Add flight passenger (dedicated for timeline-v2 flight-information component)
export const addFlightPassenger = async (params) => {
  try {
    const url = "/api/v2/bookings";

    const token = await getToken();

    const promises = params.bookings.map(async (booking, index) => {


      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(booking),
        headers: {
          "Authorization": `Bearer ${token}`,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        if (response.status === 422) {
          // 422 means departure date is required for arrival flights
          const error = new Error("DEPARTURE_DATE_REQUIRED");
          error.code = 422;
          error.booking = booking;
          throw error;
        } else
          if (response.status === 400) {
            throw new Error(
              "There was an issue with the flight details submitted as we cannot find a relevant flight with the given information."
            );
          } else if (response.status === 500) {
            throw new Error(
              "There was an issue connecting with the network resulting in an error. Check your connection or the PRM Server Status."
            );
          } else if (response.status === 409) {
            throw new Error(
              `A booking for this passenger ${booking.name} and flight ${booking.flightDetails.carrierCode}${booking.flightDetails.flightNumber} already exists.`,
            );
          } else if (response.status === 403) {
            throw new Error(
              json.message || `This flight may be outside of your airport or you may not have the correct permissions. Please contact your administrator.`,
            );
          } else {
            throw new Error("Unknown Error");
          }
      }
      return json


    });

    const responses = await Promise.all(promises);

    let type = '';

    // need to use iata to find where bookings will be stored
    if (responses[0] && responses[0].flightConfirmationDetails && responses[0].flightConfirmationDetails) {
      if (responses[0].flightConfirmationDetails.origin && responses[0].flightConfirmationDetails.destination) {
        // check if arrival or destination
        if (responses[0].flightConfirmationDetails.origin === params.iata) {
          type = 'departure';
        }
        else if (responses[0].flightConfirmationDetails.destination === params.iata) {
          type = 'arrival'
        }
      }
    }
    return {
      response: responses,
      type: type
    };

  } catch (error) {
    console.error('Error during addFlightPassenger submission:', error);
    throw error
  }
};

export const getFlightInformationDocument = async (params) => {


  const token = await getToken();

  const url = "/api/v1/flights/schedules/airportScheduleDocument?iata=" + params.iata + "&date=" + params.date;


  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      resolve(response.data);

    } catch (e) {
      reject(new Error("There was an issue retrieving flight feed information on the " + params.date));
    }
  });
};

export const getFlightInformationList = async ({ iata, date }) => {


  const token = await getToken();

  const url = "/api/v1/flights/schedules/airportSchedule?iata=" + iata + "&date=" + date;


  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      resolve(response.data);

    } catch (e) {
      reject(new Error("error Flight Information List"));
    }
  });
};

export const getInboundFlights = async ({ iata, date }) => {


  const token = await getToken();

  const url = "/api/v1/flights/schedules/airportScheduleDocuments?iata=" + iata + "&date=" + date + "&type=inbound";

  //console.log('getting inbound flight list : ', url)


  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Issue getting inbound flights");
      } else {
        resolve(response.data);
      }

    } catch (e) {
      //console.log('error getting inbound flights ', e)
      reject(new Error("error getting inbound flights"));
    }
  });
};

export const getOutboundFlights = async ({ iata, date }) => {


  const token = await getToken();

  const url = "/api/v1/flights/schedules/airportScheduleDocuments?iata=" + iata + "&date=" + date + "&type=outbound";
  //console.log('getting outbound flight list : ', url)

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Issue getting outbound flights");
      } else {
        resolve(response.data);
      }

    } catch (e) {
      //console.log('error getting outbound flights ', e)
      reject(new Error("error getting outbound flights"));
    }
  });
};

export const getTimelinePax = async (params) => {
  const token = await getToken();

  const url = "/api/v1/bookings/bookings/timelinePax/" + params?.iata +
    "?start=" + params.start +
    "&end=" + params.end + "&type=" + params.type;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      resolve(response.data);
    } catch (e) {
      reject(new Error("error getting timeline passengers"));
    }
  });
};

export const getAirportLocationsAnalytics = async (params) => {
  const token = await getToken();

  const url = "/api/v1/timeline/timelineDashboard/airportLocationsAnalytics/" + params?.iata +
    "?start=" + params.start +
    "&end=" + params.end + "&locationId=" + params.locationId +
    "&limit=" + params.limit + "&skip=" + params.skip;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });
      resolve(response.data);
    } catch (e) {
      reject(new Error("error getting Airport Locations Analytics"));
    }
  });
};

export const getEmployeesLatestActivity = async (params) => {
  const token = await getToken();

  const url = "/api/v1/timeline/timelineDashboard/employeesLatestActivity/" + params?.iata

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(url,
        { employeeIDS: params.employeeIDS },
        {
          headers: { "Firebase-UID": token },
        });
      resolve(response.data);
    } catch (e) {
      reject(new Error("error getting Airport Locations Analytics"));
    }
  });
};

export const setBookingLocation = async (object) => {
  const token = await getToken();

  const url = "/api/v1/bookings/bookings/setBookingLocation";

  return new Promise(async (resolve, reject) => {
    try {

      const response = await axios.patch(
        url,
        object, // Pass the data object directly here
        {
          headers: { "Firebase-UID": token }, // Headers go in this separate config object
        }
      );

      resolve(response.data);
    } catch (e) {
      reject(new Error("error getting drop off locations"));
    }
  });
};

export const toggleCheckInPause = async ({ bookingId, action, setBy, iata }) => {
  const token = await getToken();
  const url = `/api/v1/bookings/bookings/checkInPause/${bookingId}`;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.put(
        url,
        { action, setBy, iata: iata ?? "" },
        { headers: { "Firebase-UID": token } }
      );
      resolve(response.data);
    } catch (e) {
      reject(new Error(e?.response?.data?.message || "Error toggling check-in pause"));
    }
  });
};

export const getLocationsData = async (params) => {
  const token = await getToken();

  const url = "/api/v1/timeline/timelineDashboard/getLocationsData/" + params?.iata +
    "?start=" + params.start +
    "&end=" + params.end + "&locationId=" + params.locationId +
    "&limit=" + params.limit + "&skip=" + params.skip;


  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(url,
        { locationsIDS: params.locationsIDS },
        {
          headers: { "Firebase-UID": token },
        });

      resolve(response.data);

    } catch (e) {
      reject(new Error("error getting Airport Locations Analytics"));
    }
  });
};

export const unRejectPax = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const url = "/api/v1/timeline/timeline/" + params.iata + "/unRejectPax";
      const token = await getToken();
      const response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(params.body),
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error in boarding passengers"));
    }
  });
};


export const getPreAdvisedAndWalkups = async (params) => {
  const token = await getToken();

  const url = "/api/v1/timeline/timeline/getPreAdvisedAndWalkups/" + params?.iata +
    "?start=" + params.start +
    "&end=" + params.end

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });
      resolve(response.data);

    } catch (e) {
      reject(new Error("error getting PreAdvisedAndWalkups Analytics"));
    }
  });
};

export const getPassengerFlightList = async (params) => {
  let url = "/api/v1/timeline/timeline/" + params.iata + '/passengerList?' +
    'flightNumber=' +
    params.flightNumber +
    '&departureDate=' +
    params.departureDate + "&type=" + params.type;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(`${url}`, {
        method: "GET",
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });


      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad response from server");
      }

      let json = await response.json();

      resolve(json);

    } catch (e) {
      console.log('error', e)
      reject(new Error("Issue getting passenger list"));
    }
  });

};

export const selectPassengers = async (data) => {
  const url = "/api/v1/timeline/timeline/selectPassengers/" + data?.taskId;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data.body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad passengers details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error selecting passenger"));
    }
  });
};

export const deleteTimelineJob = async (params) => {
  const jobId = typeof params === 'object' ? params?.jobId : params;
  const body = typeof params === 'object' ? params?.body : {};
  const url = "/api/v1/timeline/timeline/deleteTimelineJob/" + jobId;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad paxCheckOut details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error paxCheckOut"));
    }
  });
};

export const updateOldEmployeeProfile = async (params) => {

  const token = await getToken();

  const url = "/api/v1/mobileusers/user/updateOldEmployee";

  const body = {
    email: params.email,
    password: params.password,
  };

  const config = {
    headers: {
      "Firebase-UID": token,
    },
  };

  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.put(url, body, config);

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad user details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("error updating old employees..."));
    }
  });
}



export const saveEmployeeShiftService = async (params) => {
  const url = "/api/v1/timeline/staff/staff-shift"

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to save employee shift");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error saving shift "));
    }
  });
}
export const getComparisonReportService = async (params) => {
  const url = `/api/v1/timeline/tasks/comparisonreport/${params.airport}?startDate=${params.startDate}&endDate=${params.endDate}`

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to fetch report data");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error getting comparison report data "));
    }
  });
};
export const getProductivityReportService = async (params) => {
  const url = `/api/v1/timeline/staff/productivity-report/${params.airport}?startDate=${params.startDate}&endDate=${params.endDate}`

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to fetch report data");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error getting comparison report data "));
    }
  });
};

export const getStaffShiftsReportService = async (params) => {
  const url = `/api/v1/timeline/staff/staff-shifts-report/${params.airport}?startDate=${params.startDate}&endDate=${params.endDate}`

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to fetch staff shifts report data");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error getting staff shifts report data"));
    }
  });
};

export const getSessionReportService = async (params) => {
  const url = `/api/v1/mobileusers/sessions/${params.airport}/report?startDate=${params.startDate}&endDate=${params.endDate}&type=${params.type}`;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to fetch session report data");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error getting session report data"));
    }
  });
};


export const sendDispatcherMessage = async (params) => {
  const url = `/api/v1/timeline/messages/sendDispatcherMessage/${params?.iata}`

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params?.body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to send Dispatcher Message");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error sending Dispatcher Message"));
    }
  });
}

export const setEmployeeMessagesToSeen = async (params) => {
  const url = `/api/v1/timeline/messages/setEmployeeMessagesToSeen/${params?.iata}?conversationId=${params?.conversationId}&source=PORTAL`;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to send Dispatcher Message");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error sending Dispatcher Message"));
    }
  });
}

export const createFlightConversation = async (params) => {
  const url = `/api/v1/timeline/messages/createFlightConversation/${params?.iata}`

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params?.body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to create flight conversation");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error creating flight conversation"));
    }
  });
};


export const sendFlightMessage = async (params) => {
  const url = `/api/v1/timeline/messages/sendFlightMessage/${params?.iata}`

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params?.body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to send Flight Message");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error sending Flight Message"));
    }
  });
}


export const setFlightMessagesToSeen = async (params) => {
  const url = `/api/v1/timeline/messages/setFlightMessagesToSeen/${params?.conversationId}?userId=${params?.userId}`;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to set Flight Messages To Seen");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error setting Flight Messages To Seen"));
    }
  });
};

export const getFlightConversation = async (convId) => {
  const url = `/api/v1/timeline/messages/getFlightConversation/${convId}`

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to fetch report data");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error getting comparison report data "));
    }
  });
};


export const createEquipmentService = async (data) => {
  const url = "/api/v1/timeline/staff/equipments"

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      console.log(data);

      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to save  airport's equipments");
      }

      console.log(json);
      resolve(json);
    } catch (e) {
      reject(new Error("Error saving equipments "));
    }
  });
}

export const getStaffEquipmentsService = async (airport) => {
  const url = "/api/v1/timeline/staff/equipments/" + airport

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to save  staff's equipments");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error saving equipments "));
    }
  });
}
export const updateEquipmentsService = async (data) => {
  const url = "/api/v1/timeline/staff/equipments/" + data.id

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "PATCH",
        body: JSON.stringify(data.body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to update  staff's equipments");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error updating equipments "));
    }
  });
};

export const getTimelineAppSettings = async (iata) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!iata) {
        throw new Error("Airport (iata) is required");
      }

      const timelineSettingsCollection = collection(firestore, "timeline-settings");
      const settingsQuery = query(timelineSettingsCollection, where("iata", "==", iata));
      const querySnapshot = await getDocs(settingsQuery);

      if (querySnapshot.empty) {
        resolve(null);
        return;
      }

      const documentData = querySnapshot.docs[0].data() || {};
      resolve({
        iata,
        settings: documentData.settings || {
          viewAppTasks: "all",
        },
      });
    } catch (error) {
      reject(new Error("Error fetching view app tasks"));
    }
  });
};

export const updateTimelineAppSettings = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      console.log("params", params);
      const token = await getToken();

      const url = "/api/v1/timeline/timeline/updateTimeLineSettings/" + params.iata;

      const response = await axios.patch(url, params.body, { headers: { "Firebase-UID": token } });
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to update timeline app settings");
      }
      resolve(response.data);
    } catch (error) {
      reject(new Error("Error updating timeline app settings: " + error));
    }
  });
};

/**
 * Create a gate relocation task
 * @param {Object} params - Task parameters
 * @param {string} params.iata - Airport IATA code
 * @param {Object} params.flight - Flight object with flightNumber and flightDate/date
 * @param {Object} params.passenger - Passenger object with _id and name
 * @param {Object} params.pickupLocation - Pickup location with _id and title
 * @param {Object} params.dropoffLocation - Dropoff location with _id and title
 * @param {string} params.pickupTime - Optional pickup time (HH:mm format)
 * @param {string} params.relocationReason - Optional reason for relocation
 * @param {string} params.notes - Optional notes
 * @returns {Promise<Object>} Created task object
 */
export const createGateRelocationTask = async (params) => {
  const token = await getToken();
  const url = `/api/v1/timeline/tasks/gateRelocation?iata=${params.iata}`;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(url,
        {
          flight: params.flight,
          passenger: params.passenger,
          pickupLocation: params.pickupLocation,
          dropoffLocation: params.dropoffLocation,
          pickupTime: params.pickupTime,
          relocationReason: params.relocationReason,
          notes: params.notes,
        },
        {
          headers: { "Firebase-UID": token },
        }
      );

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to create gate relocation task");
      }

      resolve(response.data);
    } catch (error) {
      console.error("Error creating gate relocation task:", error);
      reject(new Error(error.response?.data?.errors?.[0]?.msg || "Error creating gate relocation task"));
    }
  });
};

export const createRejectReasonsService = async (data) => {
  const url = "/api/v1/timeline/timeline/reject-reasons"

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to create  reject reasons");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error saving reject reasons "));
    }
  });
}

export const getRejectReasonsService = async ({ airport, source = "ALL" }) => {
  const url = `/api/v1/timeline/timeline/${airport}/reject-reasons?source=${source}`

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to get  reject reasons");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error getting reject-reasons "));
    }
  });
}
export const updateRejectReasonsService = async (data) => {
  const url = `/api/v1/timeline/timeline/${data.airport}/reject-reasons`

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "PATCH",
        body: JSON.stringify({ reasons: data.reasons }),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        console.log(json, "JSon", response.statusText)
        throw new Error("Failed to update  reject reasons");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error updating reject reasons "));
    }
  });
}


export const sendBroadcastMessage = async (params) => {
  const url = `/api/v1/timeline/messages/sendBroadcastMessage/${params?.iata}`

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params?.body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to send Dispatcher Message");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error sending Dispatcher Message"));
    }
  });
}

export const getDeviceReportService = async (params) => {
  const url = `/api/v1/timeline/staff/device-report/${params.airport}?startDate=${params.startDate}&endDate=${params.endDate}`;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to fetch device report data");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error getting device report data"));
    }
  });
};

export const manualUpdateBookingsTimesService = async (params) => {
  const url = `/api/v1/timeline/timeline/manual-update-bookings_times/${params?.iata}`

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await fetch(url, {
        method: "PATCH",
        body: JSON.stringify(params),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Failed to manual update bookings times");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error manual updating bookings times"));
    }
  });
}